import { RootState } from 'store';

export function getIsBootstrappedSelector({ bootstrap }: RootState) {
  return bootstrap.status === 'FETCHED';
}

export function getShouldBootstrapSelector({ auth, bootstrap }: RootState) {
  return auth.status === 'AUTHENTICATED' && bootstrap.status === 'INITIAL';
}